module.exports = __webpack_public_path__ + "assets/img/101011.62d97ce7.svg";